/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRuleListConfiguration
 */
export interface SearchRuleListConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof SearchRuleListConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof SearchRuleListConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchRuleListConfiguration
     */
    readonly relevance?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SearchRuleListConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
}

export function SearchRuleListConfigurationFromJSON(json: any): SearchRuleListConfiguration {
    return SearchRuleListConfigurationFromJSONTyped(json, false);
}

export function SearchRuleListConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleListConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function SearchRuleListConfigurationToJSON(value?: SearchRuleListConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


